import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { TuiNotification } from '@taiga-ui/core';

import { BannerComponent } from './banner.component';
@NgModule({
  declarations: [BannerComponent],
  imports: [CommonModule, TuiNotification, RouterModule],
  exports: [BannerComponent],
})
export class BannerModule {}
